module.exports = __webpack_public_path__ + "static/animan-6370bc3d2386433e4e82ef8c1fdce035.png";